import { useState, useEffect } from "react";
import { Table } from "antd";
import moment from "moment";
import {
  fbGetAllGroupDetails,
  fetchTransactions,
} from "../../../services/firebaseService/endPoints/group";
import { ScreenHeader } from "../../../CommonComponents";
import SuperAdminContainer from "../SuperAdminContainer";

const columns = [
  {
    title: "Id",
    dataIndex: "groupId",
    key: "groupId",
    className: "header-white",
    width: 150,
  },
  {
    title: "Group Name",
    dataIndex: "groupName",
    width: 250,
    key: "groupName",
    className: "header-white",
  },
  {
    title: "Payment Intent Id",
    dataIndex: "paymentIntentId",
    key: "paymentIntentId",
    className: "header-white",
    width: 250,
    render: (data, record) => {
      const url = `https://dashboard.stripe.com/connect/accounts/${record.stripeId}/payments/${data}`;
      return (
        <a href={url} target="_blank" rel="noopener noreferrer">
          {data}
        </a>
      );
    },
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    className: "header-white",
    width: 50,
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    className: "header-white",
    width: 250,
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
    className: "header-white",
    width: 200,
  },
  {
    title: "Date",
    width: 200,
    dataIndex: "timestamp",
    key: "timestamp",
    className: "header-white",
    render: (data) => {
      const dateTime = moment.unix(
        parseInt(Number(`${data || 0}`.toString()) / 1000)
      );
      if (data) return <span>{dateTime.format("MMM DD YYYY")}</span>;
      return <></>;
    },
  },
  {
    title: "Time",
    width: 100,
    dataIndex: "timestamp",
    key: "timestamp",
    className: "header-white",
    render: (data) => {
      const dateTime = moment.unix(Number(`${data || 0}`.toString()));
      if (data) return <span>{dateTime.format("HH:mm:ss")}</span>;
      return <></>;
    },
  },
  {
    title: "Total amount",
    width: 100,
    dataIndex: "totalAmount",
    key: "totalAmount",
    className: "header-white",
  },
  {
    title: "Payment Type",
    width: 100,
    dataIndex: "paymentType",
    key: "paymentType",
    className: "header-white",
  },
];

const TransactionReport = () => {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const elements = document.querySelectorAll("th");
    elements.forEach((elem) => {
      elem.style.backgroundColor = "#000000";
    });

    setLoading(true);
    fbGetAllGroupDetails().then((groups) => {
      groups.forEach((group) => {
        const groupDetails = {
          groupName: group.groupName,
          groupId: group.id,
          stripeId: (group.paymentDetails || {}).stripeAccountId || "",
        };
        fetchTransactions(group.id, groupDetails).then((data) => {
          setTableData((prev) => {
            const newTableData = [...(data || []), ...(prev || [])];
            newTableData.sort((a, b) => b.timestamp - a.timestamp);
            return newTableData;
          });
          setLoading(false);
        });
      });
    });
  }, []);

  return (
    <SuperAdminContainer>
      <ScreenHeader title="Transactions" elementCount={tableData.length} />
      <Table
        loading={loading}
        columns={columns}
        bordered
        dataSource={tableData}
        bodyStyle={{ backgroundColor: "#ffffff" }}
        scroll={{ x: "max-content" }}
        pagination={{
          position: ["bottomLeft"],
          defaultPageSize: 50,
          showSizeChanger: true,
          pageSizeOptions: [10, 20, 50, 100],
        }}
      />
    </SuperAdminContainer>
  );
};

export default TransactionReport;
